import {ref, Ref} from "vue"

const assuranceAnnulationDecision: Ref<string> = ref("")

export default assuranceAnnulationDecision